import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "wo-role-container"
};
const _hoisted_2 = {
  class: "wo-role-list"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "role-basic-info"
};
const _hoisted_5 = {
  style: {
    "margin-right": "16px"
  }
};
const _hoisted_6 = {
  class: "info-container"
};
const _hoisted_7 = {
  class: "nickname"
};
const _hoisted_8 = {
  class: "second-info"
};
const _hoisted_9 = {
  class: "basic second-info"
};
const _hoisted_10 = {
  class: "basic"
};
const _hoisted_11 = {
  key: 1,
  class: "pagination-container"
};
import { computed, onMounted, ref } from 'vue';
import { ElImage, ElMessage, ElPagination, ElRow } from 'element-plus';
import { getGender } from '@/tools/utils';
import RoleCard from '@/components/Role/RoleCard.vue';
import { request } from '@/manager/net_manager';
import store from "@/store"; // refs

export default {
  __name: 'WORoleList',

  setup(__props) {
    const dataArray = ref([]);
    const role = ref(null);
    const pagerCount = ref(5);
    const size = ref(16);
    const total = ref(0);
    const page = ref(1); // computed

    const worldOutlook = computed(() => store.state.world_outlook); // functions

    const getData = () => {
      if (worldOutlook.value !== null) {
        let parameters = {
          'page': page.value,
          'size': size.value,
          'world_outlook_id': worldOutlook.value.id
        };
        request('world_outlook/get_wo_roles/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            dataArray.value = response.data.roles;
            total.value = response.data.numbers;
          } else {
            ElMessage.error(response.msg);
          }
        });
      }
    };

    const getLevelDesc = item => {
      const realm = `${item.realm} ${item.level}`;
      const experience = `(${item['experience']}/${item['critical_experience']})`;
      return `${realm} ${experience}`;
    };

    const getStatusDesc = item => {
      let sanityPoint = parseInt(item['sanity_point'] ?? '0');
      let mythology = parseInt(item['mythology'] ?? '0');

      if (sanityPoint + mythology > 100) {
        sanityPoint = `${(100 - mythology).toString()}/${sanityPoint}`;
      }

      return `HP：${item?.health_point} MP：${item?.magic_point} SAN：${sanityPoint}`;
    }; // const getDamageDesc = (item) => {
    //   return `物理强度: ${item?.damage_bonus} 灵体强度: ${item?.pow_damage_bonus}`
    // }


    const selectedRole = item => {
      role.value = item;
    };

    const closeRole = () => {
      role.value = null;
    };

    const handlePageChange = index => {
      page.value = index - 1;
      getData();
    }; // lifecycle


    onMounted(() => {
      page.value = 0;
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      return _openBlock(), _createElementBlock("div", null, [role.value !== null ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(RoleCard, {
        "role-id": role.value.id,
        apostleMode: true,
        onCloseRole: closeRole
      }, null, 8, ["role-id"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, key) => {
        return _openBlock(), _createElementBlock("div", {
          key: key,
          class: "prev-role-item",
          onClick: $event => selectedRole(item)
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(ElImage), {
          src: item.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(ElRow), {
          style: {
            "align-items": "flex-end",
            "justify-content": "space-between"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_7, _toDisplayString(item.nickname), 1), _createElementVNode("text", _hoisted_8, _toDisplayString(getLevelDesc(item)), 1)]),
          _: 2
        }, 1024), _createVNode(_unref(ElRow), {
          class: "basic"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, "神秘 -> " + _toDisplayString(item.mysterious_level), 1)]),
            _: 2
          }, 1024), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createElementVNode("text", null, "资产 -> " + _toDisplayString(item.wealth_point), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createElementVNode("text", _hoisted_9, _toDisplayString(item['age']) + "岁  |  " + _toDisplayString(item['nationality']) + "  |  " + _toDisplayString(item['race']) + "  |  " + _toDisplayString(_unref(getGender)(item['gender'])) + "  |  " + _toDisplayString(item['work']) + "  |  " + _toDisplayString(item['era']) + " 链接天命 ", 1), _createElementVNode("text", _hoisted_10, _toDisplayString(getStatusDesc(item)), 1)])])], 8, _hoisted_3);
      }), 128))]), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_unref(ElPagination), {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true)]);
    };
  }

};